import React from 'react';
export function Toggle({
  checked,
  onChange
}: {
  checked: boolean;
  onChange: (c: boolean) => void;
}) {
  return <button type="button" className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${checked ? 'bg-orange-500' : 'bg-gray-200'}`} onClick={() => onChange(!checked)} data-id="element-3635">
      <span aria-hidden="true" className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${checked ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-3636" />
    </button>;
}